<template>
  <!-- dialog add people -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'900px'"
    :modalAppendToBody="modalAppendToBody"
    :appendToBody="true"
    :classDialog="'add-people-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">Thêm người tham gia</h3>
      <el-row :gutter="12" class="margin-bottom-10">
        <el-col :span="17" class="flex-row flex__left">
          <el-input
            v-model="keyword"
            size="mini"
            placeholder="Gõ tên để bắt đầu tìm kiếm"
            class="style-fullWidth input-border__bottom input-border__radius__0"
            @keydown.enter.exact.native="search"
          ></el-input
          >&nbsp;&nbsp;
        </el-col>
      </el-row>

      <!-- default-expand-all -->
      <el-tree
        :default-expanded-keys="expendDepartment()"
        :data="dataTree"
        node-key="id"
        ref="tree"
        class="filter-tree-task"
        highlight-current
        v-loading="isLoadingPar || isLoading"
        :expand-on-click-node="false"
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1">
            <span>
              <el-checkbox
                v-model="data.checked"
                size="medium"
                @change="checkedChangeEvent(data)"
              >
                <span class="font-size__medium">&nbsp;{{ data.label }}</span>
              </el-checkbox>
            </span>
          </div>
        </div>
      </el-tree>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button class="dialogBtnPrimary" @click="submit">
          <i class="fas fa-check-circle"></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button class="btn__cancel btn-none__border" @click="cancel">
          <i class="fas fa-ban"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import h from "../../../services/h";
import utils from "../../../services/utils";
import constants from "../../../constants";

export default {
  name: "dialog-add-people",
  props: [
    "isOpen",
    "addedPeopleIds",
    "listUser",
    "selectedUser",
    "modalAppendToBody",
    "listDept",
    "isLoadingPar",
  ],
  filters: { buildShortNameFilter },
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    VuePerfectScrollbar,
  },
  data() {
    return {
      isLoading: false,
      keyword: null,
      userDeptRoleViews: [],
      allUserDeptRoleViews: [],
      checkAll: false,
      dataTree: null,
      departments: [],
      selectedHandlersData: [],

      settings: {
        maxScrollbarLength: 350,
      },
    };
  },

  computed: {
    deptId() {
      return this.$store.getters.userDeptRole
        ? this.$store.getters.userDeptRole.deptId
        : null;
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
  },
  watch: {
    listUser() {
      this.allUserDeptRoleViews = this.listUser;
      if (this.listDept && this.listDept.length && this.listUser && this.listUser.length) {
        this.isLoading = true;
        this.convertDataToTree(this.allUserDeptRoleViews).then((res) => {
          this.isLoading = false;
        });
      }
    },
    listDept() {
      this.departments = this.listDept;
      if (this.listDept && this.listDept.length && this.listUser && this.listUser.length) {
        this.isLoading = true;
        this.convertDataToTree(this.allUserDeptRoleViews).then((res) => {
          this.isLoading = false;
        });
      }
    },
  },

  async created() {
    this.departments = this.listDept;
    this.selectedHandlersData = this.selectedUser;
    this.allUserDeptRoleViews = this.listUser.map((item) => {
      return {
        ...item,
        selected: true,
        checked: this.addedPeopleIds.indexOf(item.id) !== -1,
      };
    });
    this.convertDataToTree(this.allUserDeptRoleViews);
  },

  methods: {
    expendDepartment() {
      return (
        (this.dataTree &&
          this.dataTree.length < 4 &&
          this.dataTree.map((x) => x.id)) ||
        []
      );
    },

    // Set parent for child node
    setParentChildren(node, childNodes) {
      this.$set(node, "children", childNodes);
      h.each(childNodes, (childNode) => {
        this.$set(childNode, "parent", node);
        this.setParentChildren(childNode, childNode.children);
      });
    },

    // Điền dữ liệu thay đổi
    checkedChangeEvent(data) {
      this.checkedChange(data);
    },

    // Điền dữ liệu thay đổi
    checkedChange(data) {
      let checked = data.checked;
      if (!data.children || !data.children.length) {
        let nodeType = data.nodeType;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            this.addOrRemoveToSelectedHandlers(data);
            break;
          default:
            break;
        }
      } else {
        this.checkedAllChildren(data, checked);
      }
      this.updateCheckedForParent(data);
    },

    // select tất cả các node con
    checkedAllChildren(data, checked) {
      h.each(data.children, (child) => {
        let checkedState = child.checked || false;
        if (checkedState !== checked) {
          this.$set(child, "checked", checked);
          this.checkedChange(child);
        }
      });
    },

    // Bỏ chọn node
    removeFromSelectedHandlersData(item) {
      this.$set(item.data, "checked", false);
      this.addOrRemoveToSelectedHandlers(item.data);
      this.updateCheckedForParent(item.data);
    },

    // Cập nhật chọn node cha
    updateCheckedForParent(data) {
      let parent = data.parent;
      if (!parent || !parent.children || !parent.children.length) return;
      let currentCheckedState = parent.checked;
      let newCheckedState = !h.exists(
        parent.children,
        (child) => !child.checked
      );
      if (currentCheckedState !== newCheckedState) {
        this.$set(parent, "checked", newCheckedState);
        this.updateCheckedForParent(parent);
      }
    },

    // Bỏ hoặc thêm chọn node
    addOrRemoveToSelectedHandlers(data) {
      let checked = data.checked;
      let index = h.indexOf(
        this.selectedHandlersData,
        (item) => item.data === data
      );
      if (checked) {
        if (index === -1) this.selectedHandlersData.push({ data: data });
      } else {
        this.selectedHandlersData.splice(index, 1);
      }
    },

    // Convert
    list_to_tree(list) {
      let map = {};
      let node;
      let roots = [];
      let i;

      for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i; // initialize the map
      }

      for (i = 0; i < list.length; i += 1) {
        node = list[i];
        if (list[map[node.parentId]]) {
          // if you have dangling branches check that map[node.parentId] exists
          list[map[node.parentId]] &&
            list[map[node.parentId]].children.push(node);
        } else {
          roots.push(node);
        }
      }
      return roots;
    },

    checkedData(data) {
      return !!this.selectedHandlersData.find(
        (item) => item.data.id === data.id
      );
    },

    // Sắp xếp lại loại tài liệu từ trên xuống
    orderDocType(groups) {
      let newGroups = [];
      newGroups.push(groups.find((item) => item.id === "TCT"));
      h.each(newGroups, (element) => {
        groups
          .filter((item) => item.parentId === element.id)
          .map((item) => {
            newGroups.push(item);
          });
      });
      return newGroups;
    },

    async convertDataToTree(users) {
      users = users.map((item) => {
        return {
          ...item,
          label: item.fullName + ` (${item.positionName} - ${item.deptName})`,
          selected: true,
          nodeType: "userDeptRole",
        };
      });
      this.departments = this.departments.map((item) => {
        let children = users.filter((user) => user.deptId === item.id);
        return {
          ...item,
          label: item.deptName,
          children,
          nodeType: "dept",
        };
      });
      let departmentGenTree = [];
      this.departments.forEach((element) => {
        if (
          departmentGenTree.find((x) => x.parentId === element.id) ||
          element.children.length
        ) {
          departmentGenTree.push(element);
          this.selectedDeptNode(element);
        }
      });
      this.dataTree = this.list_to_tree(departmentGenTree);
      h.each(this.dataTree, (root) => {
        utils.hieuChinhTreeByOrder(root);
        this.setParentChildren(root, root.children);
      });
    },

    // Chọn node dept/position nếu all child selected
    selectedDeptNode(node) {
      if (
        node.nodeType === "dept" &&
        node.children.length &&
        !node.children.find((x) => !x.checked)
      ) {
        this.$set(node, "checked", true);
      }
    },

    submit() {
      this.$emit("submit", { userDeptRoleViews: this.selectedHandlersData });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    search() {
      this.checkAll = false;
      let userDeptRoleViews = this.keyword
        ? h.findAll(this.allUserDeptRoleViews, (userDeptRoleView) =>
            utils.isUserDeptRoleMatchWithQueryByName(
              userDeptRoleView,
              this.keyword
            )
          )
        : this.allUserDeptRoleViews;
      this.convertDataToTree(userDeptRoleViews);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/phonghop/dialog-add-peopleV3.vue